export default {
  title: {
    en: 'Create Your Avatar!',
    it: 'Crea Il Tuo Avatar!'
  },

  description: {
    en: 'Design fun avatars for every family member and get ready for fun challenges!',
    it: 'Crea gli avatar per tutti i membri della tua famiglia e preparati a sfide divertenti.'
  },

  button: {
    en: 'Okay!',
    it: 'Ho Capito'
  }
};
